import Storage from './Storage';

/**
 * Store DataCategoryAll
 * 
 */
class DataCategoryAll extends Storage {
    storeName = 'data_category_all_';
    hasOldKey = true;

    /**
     * DataCategoryAll constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }


    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        let returnData = JSON.stringify(data.data);//data, success, total
        return returnData;
    }

}

export default DataCategoryAll;